import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

// withCredentials=false so cross-origin POSTs work behind any ingress that
// emits Access-Control-Allow-Origin: *. Auth is carried by the Bearer token
// (Authorization header) instead of cookies — see interceptor below.
const api = axios.create({
  baseURL: API,
  withCredentials: false,
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('karency_token');
  if (token) {
    config.headers = config.headers || {};
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export function formatApiError(error) {
  // Network/CORS failure — axios sets e.message but no response
  if (error && error.isAxiosError && !error.response) {
    return `Can't reach the server. Check your connection and try again.`;
  }
  const detail = error?.response?.data?.detail ?? error;
  if (detail == null) return 'Something went wrong.';
  if (typeof detail === 'string') return detail;
  if (Array.isArray(detail)) {
    return detail.map((e) => (e && typeof e.msg === 'string' ? e.msg : JSON.stringify(e))).join(' ');
  }
  if (detail && typeof detail.msg === 'string') return detail.msg;
  if (error?.message) return error.message;
  return String(detail);
}

export default api;
